// import iconWinner from "../../../../../assets/images/Event-2026/winner.svg";
import iconWinnerThadingyut from "../../../../../assets/images/Mini-Game/thadingyut-2025-theme/winner-icon.png";
import iconWinnderNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/icon-winner.png";
import styled from "styled-components";
import PopupWinner from "../PopupFooter/PopupWinner";
import React, { useEffect, useState } from "react";
import PopupRanking from "../PopupFooter/PopupRanking";
import IconRanking from "../IconRanking";
import { useLocation } from "react-router-dom";
import { useNavigate } from "@hooks/useNavigate";
import {
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../../helper/const";
// import { IS_EVENT_THADINGYUT_2025_THEME } from "../../../../../helper/const";

export default function ActionComponent() {
  const [isShowPopupHistory, setIsShowPopupHistory] = useState(false);
  const [isShowPopupRanking, setIsShowPopupRanking] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  useEffect(() => {
    if (location?.state?.isShowPopupRanking) {
      setIsShowPopupRanking(true);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);

  return (
    <>
      {isShowPopupHistory ? (
        <PopupWinner
          setIsShowPopupHistory={setIsShowPopupHistory}
          isShowPopupHistory={isShowPopupHistory}
        />
      ) : null}
      {isShowPopupRanking ? (
        <PopupRanking
          isOpen={isShowPopupRanking}
          setIsOpen={setIsShowPopupRanking}
        />
      ) : null}
      <Container
        className={`${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""
          } ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""}`}
      >
        {IS_EVENT_THADINGYUT_2025_THEME ? (
          <img
            srcSet={`${iconWinnerThadingyut} 2x`}
            alt=''
            className={`icon-winner__collect scale-hover-item `}
            onClick={() => setIsShowPopupHistory(true)}
          />
        ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
          <img
            srcSet={`${iconWinnderNewYear} 2x`}
            alt=''
            className={`icon-winner__collect scale-hover-item `}
            onClick={() => setIsShowPopupHistory(true)}
          />
        ) : (
          <></>
          //  <img
          //   src={iconWinner}
          //   alt=''
          //   className={`icon-winner__collect scale-hover-item `}
          //   onClick={() => setIsShowPopupHistory(true)}
          // />
          // <img
          //   src={iconWinner}
          //   alt=''
          //   className={`icon-winner__collect scale-hover-item `}
          //   onClick={() => setIsShowPopupHistory(true)}
          // />
        )}
        <div onClick={() => setIsShowPopupRanking(true)}>
          <IconRanking hiddenClose />
        </div>
      </Container>
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 3;

  &.new-year-25-theme {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      .slideshow {
        width: 120px!important;
        height: 86px!important;
        position: relative;
        overflow: visible;
        img {
          object-fit: contain;
        }

        @media (max-width: 567px) {
          width: 100px !important;
          height: 72px !important;
        }
      }
    }

    .icon-winner__collect {
      width: 105px;
      height: auto;

      @media (max-width: 576px) {
        width: 85px;
      }
    }
  }

  .container-icon-event-2025.container-icon-event-2025__minigame {
    .slideshow {
      width: 120px !important;
      height: 88px !important;
      position: relative;
      /* overflow: hidden; */
      overflow: visible;
    }
  }

  @media (max-width: 768px) {
    .icon-winner__collect {
      width: 110px;
    }

    .container-icon-event-2025.container-icon-event-2025__minigame {
      .slideshow {
        width: 110px !important;
        height: 85px !important;
        position: relative;
        overflow: hidden;
      }
    }
  }

  @media (max-width: 576px) {
    .icon-winner__collect {
      width: 90px;
      height: 67px;
    }
    .container-icon-event-2025.container-icon-event-2025__minigame {
      .slideshow {
        width: 100px !important;
        height: 75px !important;
        position: relative;
        overflow: hidden;
      }
    }
    margin: 0 8px;
  }

  &.thadingyut-theme {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      .slideshow {
        width: 120px !important;
        height: 120px !important;
        position: relative;
        top: -5px;
        overflow: hidden;
      }
    }
    .icon-winner__collect {
      position: relative;
      top: -15px;
    }

    @media (max-width: 768px) {
      .container-icon-event-2025.container-icon-event-2025__minigame {
        .slideshow {
          width: 110px !important;
          height: 110px !important;
          position: relative;
          top: -6px;
          overflow: hidden;
        }
      }
    }

    @media (max-width: 576px) {
      .icon-winner__collect {
        width: 80px;
        height: auto;
      }

      .container-icon-event-2025.container-icon-event-2025__minigame {
        .slideshow {
          width: 100px !important;
          height: 100px !important;
          position: relative;
          overflow: hidden;
        }
      }
    }
  }
`;
